import * as Yup from 'yup';

import { Form, Formik } from 'formik';
import {
  InputForm,
  Label,
  NextBtn,
  RightInputWrapper,
  TextareaForm,
  TwoInputWrapper,
  InputPhone,
  selectStyleLarge,
} from '../../Form/elements';
// import { InputPhone, selectStyleLarge } from 'src/components/Form/elements';
import { Sentence, SentenceSmall, UppercaseWords } from 'src/components/Typography';

import { AnchorButton } from 'src/components/Button';
import ContactFormSubjects from 'src/data/ContactFormSubjects';
import Cookies from 'js-cookie';
import ErrorMessage from '../../Form/ErrorMessage';
import { GRC } from 'src/components/Form';
import Questions from 'src/components/Icons/Questions';
import React from 'react';
import Select from 'react-select';
import axios from 'axios';
import colors from 'src/style/colors';
import { flags } from '../../Icons/Flags';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import { mediaQueries } from 'src/style/breakpoints';
import { useRestoreFormManager } from 'src/utils/RestoreForm';

const FormBlockSchema = Yup.object().shape({
  subject: Yup.string().required('Champ obligatoire'),
  firstName: Yup.string().required('Champ obligatoire'),
  lastName: Yup.string().required('Champ obligatoire'),
  email: Yup.string()
    .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Email non valide')
    .required('Champ obligatoire'),
  phoneNumber: Yup.string()
    .required('Champ obligatoire')
    .test({
      test: (num) => {
        if (num) {
          if (num.indexOf('+330') !== -1) {
            num = num.replace('+330', '+33');
            return isPossiblePhoneNumber(num);
          } else {
            return isPossiblePhoneNumber(num);
          }
        }
      },
      message: 'Numéro de téléphone non valide',
    }),
  message: Yup.string().required('Champ obligatoire'),
});

const FORM_NAME = 'contact-form';
const action = 'Contact';

const FormBlock = ({ onFormSuccess }) => {
  const manager = useRestoreFormManager();
  const [GRCtoken, setGRCToken] = React.useState(null);
  const [formError, setFormError] = React.useState(false);
  const initialValues = {
    subject: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    message: '',
    ...(manager.get(FORM_NAME) || {}),
  };

  return (
    <GRC setGRCToken={setGRCToken} action={action}>
      <div
        css={{
          display: 'flex',
          flexDirection: 'column-reverse',
          [mediaQueries.desktopUp]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          },
        }}
      >
        <Formik
          initialValues={initialValues}
          initialErrors={initialValues}
          validateOnChange={true}
          validationSchema={FormBlockSchema}
          validate={async (values) => {
            manager.set(FORM_NAME, values);
          }}
          onSubmit={async (values) => {
            if (!GRCtoken) {
              setFormError(true);
            }
            setFormError(false);
            let { firstName, lastName, phoneNumber, email, message, subject } = values;

            try {
              const utmSource = Cookies.get('tracking') || Cookies.get('utm_source') || '';
              const gclid = Cookies.get('_gcl_aw') || '';
              const fbclid = Cookies.get('fbclid') || '';
              const referrer = Cookies.get('referrer') || '';

              const response = await axios.post(
                `${process.env.GATSBY_BASE_URL_NEW_API}/forms/contact-us`,
                {
                  firstName,
                  lastName,
                  phoneNumber,
                  email,
                  message,
                  subject,
                  utmSource,
                  gclid,
                  fbclid,
                  referrer,
                  GRCtoken,
                  action,
                  source: document.location.href,
                  track: {
                    utmSource: Cookies.get('utm_source') || '',
                    utmMedium: Cookies.get('utm_medium') || '',
                    utmCampaign: Cookies.get('utm_campaign') || '',
                    utmCampaignId: Cookies.get('utm_campaign_id') || '',
                    adGroupName: Cookies.get('adgroup_name') || '',
                    utmAdGroupId: Cookies.get('utm_adgroup_id') || '',
                    utmTerm: Cookies.get('utm_term') || '',
                    matchType: Cookies.get('matchtype') || '',
                    utmContent: Cookies.get('utm_content') || '',
                  },
                }
              );

              if (response.data && response.data.message === 'MESSAGE SENT') {
                window.dataLayer.push({
                  event: 'subjectSelection',
                  subject: subject?.value,
                });
                if (window.lintrk) window.lintrk('track', { conversion_id: 9849692 });
                onFormSuccess();
              }
            } catch (error) {
              console.error(error.message);
              setFormError(true);
            }
          }}
        >
          {({ errors, handleChange, touched, values, setFieldValue, isSubmitting }) => {
            const isDisabled = () => {
              try {
                FormBlockSchema.validateSync(values);
                return false;
              } catch (error) {
                return true;
              }
            };
            return (
              <Form>
                <div
                  css={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                  data-cy="messageTopic"
                >
                  <div css={{ display: 'flex', flexDirection: 'row' }}>
                    <Label>Objet de votre message&nbsp;</Label>
                    <SentenceSmall>*</SentenceSmall>
                  </div>
                  <Select
                    styles={selectStyleLarge}
                    name="subject"
                    placeholder="Sélectionner..."
                    onChange={(value) => {
                      setFieldValue('subject', value);
                    }}
                    value={values.subject}
                    options={ContactFormSubjects}
                    errorStyle={errors.email && touched.email ? true : false}
                  />
                  <ErrorMessage
                    isVisible={errors.subject && touched.subject}
                    message={errors.subject}
                  />
                  <TwoInputWrapper css={{ paddingTop: 45 }}>
                    <div>
                      <div css={{ display: 'flex', flexDirection: 'row' }}>
                        <Label>Prénom&nbsp;</Label>
                        <SentenceSmall>*</SentenceSmall>
                      </div>
                      <InputForm
                        name="firstName"
                        onChange={handleChange}
                        value={values.firstName}
                        errorStyle={errors.firstName && touched.firstName ? true : false}
                      />
                      <ErrorMessage
                        isVisible={errors.firstName && touched.firstName}
                        message={errors.firstName}
                      />
                    </div>
                    <RightInputWrapper>
                      <div css={{ display: 'flex', flexDirection: 'row' }}>
                        <Label>Nom&nbsp;</Label>
                        <SentenceSmall>*</SentenceSmall>
                      </div>

                      <InputForm
                        name="lastName"
                        errorStyle={errors.lastName && touched.lastName ? true : false}
                        onChange={handleChange}
                        value={values.lastName}
                      />
                      <ErrorMessage
                        isVisible={errors.lastName && touched.lastName}
                        message={errors.lastName}
                      />
                    </RightInputWrapper>
                  </TwoInputWrapper>

                  <TwoInputWrapper padding>
                    <div>
                      <div css={{ display: 'flex', flexDirection: 'row' }}>
                        <Label>Email&nbsp;</Label>
                        <SentenceSmall>*</SentenceSmall>
                      </div>
                      <InputForm
                        name="email"
                        type="text"
                        onChange={handleChange}
                        errorStyle={errors.email && touched.email ? true : false}
                        value={values.email}
                      />
                      <ErrorMessage
                        isVisible={errors.email && touched.email}
                        message={errors.email}
                      />
                    </div>
                    <RightInputWrapper>
                      <div css={{ display: 'flex', flexDirection: 'row' }}>
                        <Label>Téléphone&nbsp;</Label>
                        <SentenceSmall>*</SentenceSmall>
                      </div>

                      <InputPhone
                        errors={errors}
                        touched={touched}
                        placeholder="Entrez votre numéro"
                        autoComplete="tel"
                        country="FR"
                        defaultCountry="FR"
                        flags={flags}
                        displayInitialValueAsLocalNumber={true}
                        value={values.phoneNumber}
                        onChange={(number) => {
                          setFieldValue('phoneNumber', number);
                        }}
                      />
                      <ErrorMessage
                        isVisible={errors.phoneNumber && touched.phoneNumber}
                        message={errors.phoneNumber}
                      />
                    </RightInputWrapper>
                  </TwoInputWrapper>

                  <div css={{ paddingTop: 45 }}>
                    <div css={{ display: 'flex', flexDirection: 'row' }}>
                      <Label>Message&nbsp;</Label>
                      <SentenceSmall>*</SentenceSmall>
                    </div>
                    <TextareaForm
                      name="message"
                      onChange={handleChange}
                      errorStyle={errors.message && touched.message ? true : false}
                      value={values.message}
                    />
                    <ErrorMessage
                      isVisible={errors.message && touched.message}
                      message={errors.message}
                    />
                  </div>
                  <div css={{ paddingBottom: 10 }}>
                    <NextBtn
                      type="submit"
                      disabledStyle={isDisabled()}
                      disabled={isSubmitting}
                      isFullWidth
                    >
                      Envoyer
                    </NextBtn>
                  </div>
                  <div css={{ paddingBottom: 10 }}>
                    {formError && (
                      <ErrorMessage
                        isVisible={true}
                        message={
                          GRCtoken
                            ? 'Une erreur est survenue.'
                            : "Une erreur est survenue ! Vérifiez que vous n'êtes pas derrière un VPN. Si le problème persiste, merci de nous contacter directement."
                        }
                      />
                    )}
                  </div>
                  <SentenceSmall>* Champ obligatoire</SentenceSmall>
                </div>
              </Form>
            );
          }}
        </Formik>
        <div
          css={{
            display: 'flex',
            borderRadius: 10,
            flexDirection: 'column',
            marginBottom: 75,
            [mediaQueries.desktopUp]: {
              marginLeft: 90,
              marginBottom: 0,
              padding: 45,
              marginTop: 0,
              backgroundColor: colors.lightGrey,
            },
          }}
        >
          <div
            css={{
              [mediaQueries.desktopUp]: {
                display: 'flex',
                flexDirection: 'row',
                paddingBottom: 24,
                alignItems: 'center',
              },
              display: 'none',
            }}
          >
            <Questions css={{ marginTop: -5, marginRight: 12, width: 26 }} />
            <UppercaseWords>Vous avez une question&nbsp;?</UppercaseWords>
          </div>

          <Sentence
            css={{
              paddingBottom: 14,
              [mediaQueries.tabletLandscapeUp]: { marginTop: -25 },
              [mediaQueries.desktopUp]: { marginTop: 0 },
            }}
          >
            Vous n’avez pas trouvé l’information que vous cherchiez ? <br />
            Consultez nos questions fréquentes ou rencontrez-nous lors de nos réunions
            d’information.
          </Sentence>

          <div
            css={{
              marginTop: 20,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
              [mediaQueries.phoneOnly]: {
                flexDirection: 'column',
                width: '100%',
              },
              [mediaQueries.desktopUp]: {
                flexDirection: 'column',
                justifyContent: 'center',
                marginTop: 25,
              },
              [mediaQueries.bigDesktopUp]: {
                // flexDirection: 'row',
              },
            }}
          >
            <AnchorButton
              to="/faq"
              isSmall
              css={{
                marginBottom: 10,
                [mediaQueries.tabletPortraitUp]: {
                  marginRight: 10,
                  marginBottom: 0,
                },
                [mediaQueries.desktopUp]: {
                  marginRight: 0,
                  marginBottom: 10,
                  width: '100%',
                },
                [mediaQueries.bigDesktopUp]: {
                  // marginRight: 10,
                  // marginBottom: 0,
                },
              }}
            >
              Questions fréquentes
            </AnchorButton>
            <AnchorButton
              to="/reunion-d-information/"
              isSmall
              secondary
              css={{
                [mediaQueries.desktopUp]: {
                  width: '100%',
                },
              }}
            >
              Réunion d’information
            </AnchorButton>
          </div>
        </div>
      </div>
    </GRC>
  );
};

export default FormBlock;
